// BM-H3747 (Vanessa, 6 Oct 2026): "once sent, the editor should collapse/hide".
// After the CCL has gone to the client, the matter page shows this short
// summary in place of the editor and the AI rail. The letter can still be
// opened read-only with "Show letter".
import { CheckCircle2, Clock, FileText } from "lucide-react";
import { Button } from "./ui/button";

export default function CclSentSummary({ clientSigned = false, offSystem = false, onShow }) {
  return (
    <div
      className="flex flex-wrap items-center gap-3 border border-slate-200 rounded-md px-4 py-3 bg-slate-50"
      data-testid="ccl-sent-summary"
    >
      <FileText className="w-5 h-5 text-slate-500" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-slate-800">
          {offSystem ? "Client Care Letter sent to the client off CaseMinder" : "Client Care Letter sent to the client"}
        </div>
        <div className="text-sm text-slate-600 flex items-center gap-1" data-testid="ccl-sent-summary-status">
          {clientSigned ? (
            <>
              <CheckCircle2 className="w-4 h-4 text-emerald-600" aria-hidden="true" /> {offSystem ? "Accepted by the client" : "Signed by the client"}
            </>
          ) : (
            <>
              <Clock className="w-4 h-4 text-amber-600" aria-hidden="true" /> {offSystem ? "Waiting for the client's acceptance" : "Waiting for the client to sign"}
            </>
          )}
        </div>
      </div>
      <Button variant="outline" size="sm" onClick={onShow} data-testid="ccl-sent-summary-show">
        Show letter
      </Button>
    </div>
  );
}
